<template>
    <div>
        <div class="relative mb-2">
            <div
                class="absolute flex align-center items-center align-middle content-center"
                style="width: calc(100% - 2.5rem - 1rem); top: 50%; transform: translate(-50%, -50%)"
                v-if="progress"
            >
            <div class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1">
                <div class="w-0 py-1 rounded" :style="'width: ' + (paged ? width : progressWidth) + '%;'"
                    :class="{
                        ['bg-'+ color +'-500'] : color
                    }"
                ></div>
            </div>
            </div>

            <div
                class="w-10 h-10 mx-auto rounded-full text-lg text-white flex items-center"
                :class="{
                    ['bg-'+ color +'-900'] : active,
                    ['bg-white border-2 border-gray-200'] : !active,
                }"
            >
                <span class="text-center text-white w-full"
                    :class="{
                        ['text-gray-600'] : !active,
                    }"
                >
                    <slot name="icon" />
                </span>
            </div>
        </div>
        <div class="text-xs text-center md:text-base text-gray-900 font-bold">{{ title }}</div>
    </div>
</template>

<script>
import { ref } from '@vue/reactivity';
import { watch } from '@vue/runtime-core';
export default {
    props: {
        title: String,
        progress: {
            type: Boolean,
            default: true,
        },
        width: {
            type: [String, Number],
            default: 0,
        },
        active: Boolean,
        color: {
            type: String,
            default: 'gray'
        },
        duration: {
            type: [String, Number],
            default: 300,
        },
        paged: {
            type: Boolean,
            default: false,
        },
    },

    setup(props) {
        const
            progressWidth = ref(0),
            newWidth = ref(props.width);

        const countDownTimer = (newVal, oldVal) =>  {

            let duration = Number(props.duration);
            let st = window.performance.now();

            window.requestAnimationFrame(function step(time) {
                let diff = Math.round(time - st),
                val = Math.round(diff / duration * 100);

                if(newVal < oldVal) {
                    val = ( newVal > 0 ? newVal : oldVal ) - val;
                    val = val < newVal ? newVal : val;
                }
                else val = val > newVal ? newVal : val;

                progressWidth.value = val;

                if (diff < duration) {
                    window.requestAnimationFrame(step);
                }
            })
        };

        watch(() => props.width, (width, prevWidth) => {
            newWidth.value = width;
            countDownTimer(width, prevWidth);
        })

        return {
            progressWidth,
            newWidth,

            countDownTimer
        }
    },
}
</script>

<style>

</style>
